/* CANFOTO V67BS-R18 | Native contract evidence gate | SHADOW READ ONLY */
(function(W){'use strict';
const VERSION='CANFOTO-NORA-R18-EVIDENCE-GATE-V1';
const RULES=Object.freeze({
'youtube_reels_social::short_video_reels':['subjectCount','cameraDistance','modifier','whiteModeEvidence'],
'interview_talking_head::corporate_training_video':['speakerCount','duration','fanNoiseEvidence','cameraDistance'],
'clinic_aesthetic_dental::skin_face_capture':['criEvidence','skinToneConsistency','shadowControl','workingDistance'],
'rgb_creative_video::music_clip_scene':['rgbMode','whiteModeEvidence','sceneScale','lightRole'],
'studio_professional::campaign_ad_visual':['subjectScale','modifier','coverage','distance'],
'starter_budget_practical::small_space_solution':['roomDepth','headDimensions','fanNoiseEvidence','dimmingRange']
});
const valueKnown=x=>x!==null&&x!==undefined&&x!==''&&x!=='UNKNOWN'&&x!=='UNVERIFIED';
const frozen=x=>Object.freeze(x);
async function audit(){
 const r17=W.CANFOTO_NORA_PANEL_ROLE_VERDICT_V67BS_R17;
 const r16=W.CANFOTO_NORA_PANEL_SEMANTIC_DECISION_V67BS_R16;
 if(typeof r17?.audit!=='function'||typeof r16?.audit!=='function')throw Error('HOLD_SOURCE_R16_R17_NOT_READY');
 const [ledger,semantic]=await Promise.all([r17.audit(),r16.audit()]);
 if(ledger.status!=='PASS_LEDGER_NO_FALSE_REJECTION_WITH_SEMANTIC_HOLD'||semantic.sourceParity!==true)throw Error('HOLD_SOURCE_CERTIFICATE_MISMATCH');
 const gates=Object.entries(RULES).map(([key,fields])=>{
  const source=semantic.contracts.find(x=>x.key===key);
  const sourceFields=source?.requiredEvidence||[];
  const contractMatch=fields.length===sourceFields.length&&fields.every((x,i)=>x===sourceFields[i]);
  const unresolved=ledger.unresolvedNative.find(x=>x.key===key);
  return frozen({key,contractMatch,requiredFields:fields.slice(),missingFields:fields.slice(),confirmedFields:[],
    sourceState:unresolved?.certification||'MISSING',technicalVerdict:'HOLD_NATIVE_EVIDENCE',allowedScoreWrite:false,allowedRankWrite:false});
 });
 const roleCases=ledger.top5.map(x=>{
  const fields=(x.evidenceRequired||[]).slice();
  return frozen({key:x.key,lane:x.lane,rank:x.rank,handle:x.handle,sourceHandle:x.sourceHandle,
    role:x.role,area:x.area,effectiveWhitePowerW:x.effectiveWhitePowerW,
    r2gMainKeyEligible:x.r2gMainKeyEligible,requires:fields,missingEvidence:fields,
    photometry:'UNKNOWN',mainKeyFlagCannotRejectContextual:true,
    verdict:'HOLD_PRODUCT_ROLE_EVIDENCE',allowedAutoElimination:false,allowedScoreWrite:false});
 });
 const checks={nativeSix:gates.length===6,contractParity:gates.every(x=>x.contractMatch),
   roleCase14:roleCases.length===14,top3Eight:ledger.top3.length===8,
   noFakeEvidence:gates.every(x=>x.confirmedFields.length===0)&&roleCases.every(x=>x.photometry==='UNKNOWN'),
   noAutoRejection:roleCases.every(x=>x.allowedAutoElimination===false),
   sourcesParity:semantic.sourceParity===true};
 return frozen({task:'V67BS_R18_EVIDENCE_GATE',version:VERSION,mode:'READ_ONLY_SHADOW',
   gates,roleCases,top3Count:ledger.top3.length,top5Count:roleCases.length,
   totalNativeMissingEvidence:gates.reduce((n,x)=>n+x.missingFields.length,0),
   totalRoleEvidenceMissing:roleCases.reduce((n,x)=>n+x.missingEvidence.length,0),
   certifiedNative:0,photometryCertified:false,scoreMutation:false,rankMutation:false,fpCurveMutation:false,
   checks,status:Object.values(checks).every(Boolean)?'PASS_GATE_INTEGRITY_WITH_EVIDENCE_HOLD':'HOLD'});
}
W.CANFOTO_NORA_PANEL_EVIDENCE_GATE_V67BS_R18=frozen({version:VERSION,audit,scoreMutation:false,rankMutation:false,fpCurveMutation:false});
})(window);
